import * as Types from 'src/actions/investment/index/Types';
import {
  IndexInvestmentsAction,
  IndexInvestmentsSuccess
} from 'src/actions/investment/index/IndexInvestments.actions';
import Investment from 'src/entities/Investment';

export interface IndexInvestmentsState {
  investments: Investment[];
  loading: boolean;
  error: boolean;
}

export const initialIndexInvestmentsState: IndexInvestmentsState = {
  investments: [],
  loading: false,
  error: false,
};

export function IndexInvestmentsReducer(
  state: IndexInvestmentsState = initialIndexInvestmentsState,
  action: IndexInvestmentsAction
): IndexInvestmentsState {
  switch (action.type) {
    case Types.INDEX_INVESTMENT_ATTEMPT:
      return { ...state, loading: true, error: false };
    case Types.INDEX_INVESTMENT_SUCCESS:
      return { ...state, investments: (action as IndexInvestmentsSuccess).payload, loading: false, error: false };
    case Types.INDEX_INVESTMENT_FAILURE:
      return { ...state, loading: false, error: true, investments: [] };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/investment/IndexInvestmentsReducer.tsx